import { buildPagingLiteral, buildWhereLiteral } from '@/lib/graphql-query-builder';

/** The holidays of a day range, with whether each applies only to some cantons. */
export const buildGetHolidaysForPresenceQuery = (
  where: Record<string, unknown>,
  pageSize: number
) => `
  query {
    Holidays: getHolidays(
      where: ${buildWhereLiteral(where)}
      order: [{ field: "StartDate", direction: ASC }]
      paging: ${buildPagingLiteral(1, pageSize)}
    ) {
      items {
        ItemId
        Name
        StartDate
        IsRegional
        CantonIds
      }
    }
  }
`;
